export const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : "");

// sleep function
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
